import { useContext } from 'react';
import { LoginContext } from './LoginContext';

export function useHandleLogin() {
	const { handleLogin } = useContext(LoginContext);
	return handleLogin;
}
